<template>
    <header
        v-lazy:background-image="backgroundImage"
        class="header d-flex align-items-md-end"
    >
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-8">
                    <a
                        :href="url"
                        class="breadcrumbs color--blue-7 font-weight-bold"
                    >
                        <i class="fas fa-arrow-left mr-2"></i>
                        <span>Terug naar overzicht</span>
                    </a>
                    <h1 class="color--white">{{ title }}</h1>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import Axios from 'axios';
export default {
    props: {
        image: {
            type: String,
            default: ''
        },
        webPImage: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            url: '',
            registrationUrl: ''
        };
    },
    computed: {
        backgroundImage: function() {
            if (this.webPImage !== '' && this.$useWebP) {
                return this.webPImage;
            }
            return this.image;
        }
    },
    created() {
        const parts = window.location.pathname
            .split('?')[0]
            .split('#')[0]
            .split('/')
            .slice(1);
        if (!parts[parts.length - 1]) {
            parts.pop();
        }

        parts.pop();
        this.url = window.location.origin;
        if (sessionStorage.getItem('filtered-url') != null) {
            this.url += sessionStorage.getItem('filtered-url');
        } else {
            this.url += this.getActivitiesLink();
        }
    },
    methods: {
        getActivitiesLink() {
            Axios.get('/api/activity/getactivitieslink').then(response => {
                this.url = response.data;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.header {
    position: relative;
    min-height: 250px;
    max-height: 250px;
    width: 100%;
    padding-bottom: 150px;
    background-size: cover;
    background-repeat: no-repeat;

    @include media-breakpoint-up(sm) {
        padding-bottom: 25%;
    }

    @include media-breakpoint-up(md) {
        padding-bottom: 15%;
        min-height: 350px;
        max-height: 350px;
    }

    @include media-breakpoint-up(lg) {
        padding-bottom: 10%;
        min-height: 500px;
        max-height: 500px;
    }

    h1 {
        color: $white;
        font-size: 2.35rem;

        @include media-breakpoint-up(md) {
            font-size: 3.75rem;
        }

        @include media-breakpoint-up(lg) {
            color: $black;
        }
    }

    &:after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        width: 100%;
        padding-top: 15%;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        background-image: url(/Content/img/wave-detail.svg);

        @include media-breakpoint-up(lg) {
            padding-top: 10%;
        }
    }
}

.header:before {
    content: '';
    background-color: rgba(65, 65, 65, 0.3);
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    pointer-events: none;
}

.text-page__header .breadcrumbs {
    display: none;
}
</style>
